import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ContactEntity } from './contact.entity';
import { FileEntity } from './file.entity';

/**
 * PD-17589 — a file that belongs to a person, the way `client__file` holds a
 * company's. A new table, so it follows the current naming rule (no
 * underscore-prefixed table or columns) rather than `client__file`'s. The
 * file's type is stored on `_file._subtype` from the Contact File Type list;
 * `_file._type` is 'contact'. Merging two people moves these rows to the
 * person kept.
 */
@Index('contact_file_fk__file__id_idx', ['fkFileId'], {})
@Index('contact_file_fk_contact__id_idx', ['fkContactId'], {})
@Entity('contact_file')
export class ContactFileEntity extends BaseEntity {
	@Column('int', { name: 'fk__file__id', unsigned: true })
	public fkFileId!: number;

	@Column('int', { name: 'fk_contact__id', unsigned: true })
	public fkContactId!: number;

	@ManyToOne(() => ContactEntity, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_contact__id', referencedColumnName: 'id' }])
	public fkContact!: ContactEntity;

	@ManyToOne(() => FileEntity, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk__file__id', referencedColumnName: 'id' }])
	public fkFile!: FileEntity;
}
